module.exports = __webpack_public_path__ + "img/bank_bg_cross.a897919f.png";